import * as CANNON from 'cannon-es';
import { CylinderBufferGeometry, Float32BufferAttribute, Mesh, MeshStandardMaterial, } from 'three';
import { createBoundry } from '../utils/utils';
class Platform {
    static createCylinderPlatform(dimensions, phyicsMaterial, position, configObj, rotation) {
        const randomColor = () => {
            let n = (Math.random() * 0xfffff * 1000000).toString(16);
            return '#' + n.slice(0, 6);
        };
        const { radiusTop, radiusBottom, height, radialSegments } = dimensions;
        const geometry = new CylinderBufferGeometry(radiusTop, radiusBottom, height, radialSegments);
        const material = new MeshStandardMaterial(configObj ? configObj : { color: randomColor(), emissive: 0x0 });
        const mesh = new Mesh(geometry, material);
        mesh.receiveShadow = true;
        mesh.geometry.setAttribute('uv2', new Float32BufferAttribute(mesh.geometry.attributes.uv.array, 2));
        if (position) {
            const { x, y, z } = position;
            mesh.position.set(x, y, z);
        }
        const shape = new CANNON.Cylinder(radiusTop, radiusBottom, height, radialSegments);
        const body = createBoundry(-1, 0, 0, 0, 0, 0, rotation ? rotation : Math.PI, shape, phyicsMaterial);
        body.position.copy(mesh.position);
        return { mesh, body };
    }
}
export default Platform;
